import { SPORTS } from '../constant/sports'

const soccerLeagues = [
    {
        name: 'European Championship',
        order: 1,
    },
    {
        name: 'Champions League',
        order: 2,
    },
    {
        name: 'Europa League',
        order: 3,
    },
    {
        name: 'Premier League',
        order: 4,
    },
    {
        name: 'LaLiga',
        order: 5,
    },
    {
        name: 'Bundesliga',
        order: 6,
    },
    {
        name: 'Serie A',
        order: 7,
    },
    {
        name: 'Ligue 1',
        order: 8,
    },
    {
        name: 'Conference League',
        order: 9,
    },
]

const tennisLeagues = [
    {
        name: 'ATP London',
        order: 1,
    },
    {
        name: 'ATP Halle',
        order: 2,
    },
    {
        name: 'WTA Berlin',
        order: 3,
    },
    {
        name: 'WTA Birmingham',
        order: 4,
    },
    {
        name: 'WTA Roland Garros',
        order: 5,
    },
    {
        name: 'ATP 1000 men',
        order: 6,
    },
    {
        name: 'WTA 1000 women',
        order: 7,
    },
    {
        name: 'ATP 500 men',
        order: 8,
    },
    {
        name: 'WTA 500 women',
        order: 9,
    },
    {
        name: 'ATP 250 men',
        order: 10,
    },
    {
        name: 'WTA 250 women',
        order: 11,
    },
    {
        name: 'ATP Hamburg',
        order: 12,
    },
    {
        name: 'ATP Gstaad',
        order: 13,
    },
    {
        name: 'ATP Bastad',
        order: 14,
    },
]

export type LeaguesPriority = Record<string, Array<any>>

export const leaguesPriority: LeaguesPriority = {
    [SPORTS.SOCCER]: soccerLeagues,
    [SPORTS.TENNIS]: tennisLeagues,
}
